import React from 'react';
export function Footer() {
  return <footer className="bg-slate-900 py-12 px-4 text-center" data-id="element-35">
      <div className="mx-auto max-w-5xl" data-id="element-36">
        <p className="text-slate-400 text-xs sm:text-sm leading-relaxed mb-8 max-w-4xl mx-auto" data-id="element-37">
          These statements have not been evaluated by the Food and Drug
          Administration. This product is not intended to diagnose, treat, cure,
          or prevent any disease. Results may vary. ©{' '}
          {new Date().getFullYear()} CitrusBurn™. All rights reserved.
        </p>
        <div className="flex flex-wrap justify-center gap-6 text-sm text-slate-300" data-id="element-38">
          <a href="#" className="hover:text-white transition-colors" data-id="element-39">
            Privacy Policy
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-40">
            Terms of Service
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-41">
            Contact
          </a>
        </div>
      </div>
    </footer>;
}